<script lang="ts">
  import axios, { AxiosError } from "axios";
  import { link, navigateTo, settings, t } from "../../../core";
  import FormErrors from "../../elements/FormErrors.svelte";
  import Input from "../../elements/Input.svelte";
  import AuthForm from "./components/AuthForm.svelte";
  import { emailValid } from "./components/helpers";

  let email: string = "";
  let password: string = "";

  let errorMessage: string = "";
  let isLoading: boolean = false;
  let isDisabled: boolean = false;

  $: isDisabled = email.trim() === "" || password.trim() === "";

  function submit() {
    errorMessage = "";
    isLoading = true;

    if (emailValid(email) === false) {
      errorMessage = t("Error.InvalidEmail.Title");
      isLoading = false;
      return;
    }

    axios
      .post("/api/Customer/login", { email, password })
      .then(() => navigateTo("/"))
      .catch((err: AxiosError) => (errorMessage = err?.response?.data))
      .finally(() => (isLoading = false));
  }
</script>

<svelte:head>
  <title>{t("Page.Login.Title")}</title>
</svelte:head>

<AuthForm
  title={t("LoginPage.Login.Title")}
  submit={t("General.Login.Title")}
  {isLoading}
  {isDisabled}
  on:click={submit}
>
  <Input
    name="useremail"
    type="text"
    placeholder={t("General.Email.Title")}
    bind:value={email}
  />

  <Input
    name="userpassword"
    type="password"
    placeholder={t("General.Password.Title")}
    bind:value={password}
  />

  {#if errorMessage}
    <FormErrors {errorMessage} />
  {/if}

  <a slot="link" class="link" href={settings?.forgotPasswordPageUrl} use:link>
    {t("General.ForgotPassword.Title")}
  </a>
</AuthForm>
